<template>
  <div class="income-box">
    <hshead title="我的收益" waveBg="true"></hshead>
    <div class="income-time-select">
      <div class="this-time" @click="show=true">
        {{displayData}}
        <span>
          <img src="~@/assets/images/income/arr.png" alt />
        </span>
      </div>
    </div>
    <div class="income-top" v-if="incomeStatisticsData">
      <div class="top-left">
        <div class="this-p">总收益：{{incomeStatisticsData.total_All_Income.toFixed(2)}}</div>
        <div class="this-p">可提现：{{incomeStatisticsData.total_Status3_Income.toFixed(2)}}</div>
        <div class="this-p">待结算：{{incomeStatisticsData.total_Status2_Income.toFixed(2)}}</div>
      </div>
      <div class="top-right">
        <div class="this-img">
          <img src="~@/assets/images/income/wallet-w.png" alt />
        </div>
        <van-button class="this-btn" @click="getCash">我要提现</van-button>
      </div>
    </div>
    <div class="income-tab">
      <van-tabs v-model="tabactive" swipeable title-active-color="#007dfa" color="#007dfa">
        <van-tab title="收益明细">
          <div class="income-ul" v-if="listByIncome && listByIncome.length > 0">
            <div class="income-li" v-for="(item, index) in listByIncome" :key="index">
              <div class="left-img">
                <img src="~@/assets/images/income/wallet.png" alt />
              </div>
              <div class="center-p-box">
                <div class="center-p min">
                  订单号：
                  <span>{{item.orderId}}</span>
                </div>
                <div class="center-p">收益：￥{{item.incomeAmount.toFixed(2)}}</div>
                <div class="center-p">收益时间：{{item.createTime}}</div>
              </div>
              <div class="right-img">
                <img src="~@/assets/images/income/status1.png" alt v-if="item.status==1" />
                <img src="~@/assets/images/income/status2.png" alt v-else-if="item.status==2" />
                <img src="~@/assets/images/income/status3.png" alt v-else-if="item.status==3" />
                <img src="~@/assets/images/income/status4.png" alt v-else-if="item.status==4" />
              </div>
            </div>
          </div>
          <div style="font-size:initial;text-align:center;padding-top:5%;" v-else>没有更多了</div>
        </van-tab>
        <van-tab title="结算中">
          <div class="income-ul" v-if="listByIncome2 && listByIncome2.length > 0">
            <div class="income-li" v-for="(item, index) in listByIncome2" :key="index">
              <div class="left-img">
                <img src="~@/assets/images/income/wallet.png" alt />
              </div>
              <div class="center-p-box">
                <div class="center-p min">
                  订单号：
                  <span>{{item.orderId}}</span>
                </div>
                <div class="center-p">收益：￥{{item.incomeAmount.toFixed(2)}}</div>
                <div class="center-p">收益时间：{{item.createTime}}</div>
              </div>
              <div class="right-img">
                <img src="~@/assets/images/income/status1.png" alt v-if="item.status==1" />
                <img src="~@/assets/images/income/status2.png" alt v-else-if="item.status==2" />
                <img src="~@/assets/images/income/status3.png" alt v-else-if="item.status==3" />
                <img src="~@/assets/images/income/status4.png" alt v-else-if="item.status==4" />
              </div>
            </div>
          </div>
          <div style="font-size:initial;text-align:center;padding-top:5%;" v-else>没有更多了</div>
        </van-tab>
        <van-tab title="提现明细">
          <div class="income-ul" v-if="listByExtractCash && listByExtractCash.length > 0">
            <div class="income-li" v-for="(item, index) in listByExtractCash" :key="index">
              <div class="left-img">
                <img src="~@/assets/images/income/wallet.png" alt />
              </div>
              <div class="center-p-box">
                <!-- <div class="center-p">外部订单号：{{item.outTransNo}}</div> -->
                <div class="center-p">提现金额：￥{{item.cashAmount.toFixed(2)}}</div>
                <div class="center-p">提现时间：{{item.createTime}}</div>
              </div>
              <div class="right-img">
                <img src="~@/assets/images/income/status_1.png" alt v-if="item.status==1" />
                <img src="~@/assets/images/income/status_2.png" alt v-else-if="item.status==2" />
              </div>
            </div>
          </div>
          <div style="font-size:initial;text-align:center;padding-top:5%;" v-else>没有更多了</div>
        </van-tab>
      </van-tabs>
    </div>
    <!-- <van-tabbar v-model="active">
      <van-tabbar-item to="MissionHall" icon="todo-list-o">任务中心</van-tabbar-item>
      <van-tabbar-item to="Income" icon="chart-trending-o">收益</van-tabbar-item>
      <van-tabbar-item to="Grapher" icon="manager-o">摄影师</van-tabbar-item>
      <van-tabbar-item to="Product" icon="orders-o">商品管理</van-tabbar-item>
      <van-tabbar-item to="Other" icon="apps-o">更多</van-tabbar-item>
    </van-tabbar>-->
    <van-popup v-model="show" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        :formatter="formatter"
        @cancel="show=false"
        @confirm="show=false;searchTime = currentDate"
      />
    </van-popup>

    <!-- 确认提现 -->
    <van-dialog
      v-model="mobileCodeShow"
      title="确认提现"
      show-cancel-button
      :beforeClose="beforeClose"
      @confirm="getCashConfirm()"
      class="handle-dialog"
      confirmButtonText="确定"
      style="width:100%;height:100%;top:50%;"
    >
      <br />
      <van-cell-group>
        <van-cell title="提现金额" :value="caseAmount" />
      </van-cell-group>
      <van-cell-group>
        <van-cell title="手机号" :value="mobile" />
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="verifyCode"
          center
          clearable
          label="图形验证码"
          placeholder="输入验证码"
          :right-icon="verifyCodeImageBase64"
          class="mobileCode"
          @click-right-icon="handleVerifyCodeClick"
        >
          <!-- <van-button slot="button" size="small" type="primary" @click="getCode()">{{sendCodeText}}</van-button> -->
        </van-field>
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="mobileCode" center clearable label="短信验证码" placeholder="输入验证码">
          <van-button slot="button" size="small" type="primary" @click="getCode()">{{sendCodeText}}</van-button>
        </van-field>
      </van-cell-group>
      <div style="padding: 20px;font-size: 0.8em;"><input type="checkbox" @click="checkboxClick" />我已阅读并同意<span style="color:blue;" @click="showTiaokuan()">《lshoot服务条款》</span></div>
    </van-dialog>

    <!-- 共享经济合作伙伴协议 -->
    <van-popup
      v-model="AgreementShow"
      :style="{ 
      height: '100%',
      width: '100%',
       }"
    >
      <agreement @set-agreement-hide="AgreementShow=false"></agreement>
    </van-popup>

    <!-- 底部导航 -->
    <van-tabbar v-model="active">
      <van-tabbar-item to="MissionHall">
        <span>任务中心</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_taskCenter.active : icon_taskCenter.inactive
            "
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="Income" icon="chart-trending-o">
        <span style="color:#304378">收益</span>
        <template #icon="props">
          <img
            :src="props.active ? icon_earnings.active : icon_earnings.inactive"
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="Order" icon="chart-trending-o">
        <span>我的订单</span>
        <template #icon="props">
          <img
            :src="props.active ? icon_order.active : icon_order.inactive"
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="Center" icon="chart-trending-o">
        <span>我的</span>
        <template #icon="props">
          <img
            :src="props.active ? icon_user.active : icon_user.inactive"
          />
        </template>
      </van-tabbar-item>
    </van-tabbar>

  </div>
</template>

<script>
import hshead from "@/components/common/hshead";
import { Toast, DatetimePicker, Popup, Tab, Tabs, Tabbar, TabbarItem, Button, Dialog, CellGroup, Field, Cell } from "vant";
import { getIncomeStatistics, getStoreIncomePager, getStoreExtractCashPager } from "@/api/m/user";
import { getCash } from "@/api/m/grapher";
import { getUser, weixinBind } from "@/api/m/user";
import moment from "moment";
import { sendCode, verifyCodeImageBase64 } from "@/api/common";
import { GetWechatAuthUrl } from "@/utils/common";
import Agreement from "@/views/user/Agreement";
import Cookies from "js-cookie";
// 任务中心
import taskCenter_icon from "@/assets/images/center/nav-1.png";
import taskCenter_icon_act from "@/assets/images/center/nav-1-act.png";
//收益
import earnings_icon from "@/assets/images/center/nav-2.png";
import earnings_icon_act from "@/assets/images/center/nav-2-act.png";
//我的订单
import order_icon from "@/assets/images/center/nav-6.png";
import order_icon_act from "@/assets/images/center/nav-6-act.png";
//我的
import user_icon from "@/assets/images/center/nav-7.png";
import user_icon_act from "@/assets/images/center/nav-7-act.png";

export default {
  name: "myincome",
  data() {
    return {
      tabactive: 0,
      active: 1,
      show: false,
      AgreementShow: false, // 展示共享经济合作伙伴协议
      searchTime: new Date(), // 拿到的修改后的日期，去watch获取数据就行
      currentDate: new Date(),
      incomeStatisticsData: null,
      displayData: moment().format("YYYY年MM月"),
      //收益
      curIncomeType: 1, //收益类型；1: 摄影师拍摄收益，2: 店铺收益，3: 打赏收益
      listQueryByIncome: {
        pn: 1,
        ps: 200
      },
      listByIncome: null,
      listByIncome2: null,
      //提现
      listQueryByExtractCash: {
        pn: 1,
        ps: 200
      },
      listByExtractCash: null,
      //短信验证码
      mobileCodeShow: false,
      verifyCode: "",
      mobileCode: "",
      caseAmount: 0,
      sendCodeText: "发送",
      codeTime: 0, // 发送验证码的时间
      timeOut: "", // 倒计时事件
      verifyCodeImageBase64: "",
      //
      openid: null,
      mobile: null,
      checkboxState: null,
        icon_taskCenter: {
        active: taskCenter_icon_act,
        inactive: taskCenter_icon,
      },
      icon_earnings: {
        active: earnings_icon_act,
        inactive: earnings_icon,
      },
      icon_order: {
        active: order_icon_act,
        inactive: order_icon,
      },
      icon_user: {
        active: user_icon_act,
        inactive: user_icon,
      },
    };
  },
  watch: {
    searchTime(val) {
      this.displayData = moment(val).format("YYYY年MM月");
      this.onLoad();
    }
  },
  created() {
    let self = this;
    self.openid = Cookies.get("openid");
    let ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {      
      if (!self.openid) {
        self.redirectToWeixin();
      }
    }
    this.onLoad();
  },
  methods: {
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      }
      return value;
    },
    onLoad() {
      //获取用户收益统计数据
      this.getIncomeStatistics();
      //用户收益
      this.getStoreIncomePager();
      //提现记录
      this.getStoreExtractCashPager();
    },
    //获取用户收益统计数据
    getIncomeStatistics() {
      const params = {
        IncomeType: this.curIncomeType
        // Year: moment(this.searchTime).format('YYYY'),
        // Month: moment(this.searchTime).format('MM')
      };
      this.load(true, "加载中...");
      getIncomeStatistics(params)
        .then(response => {
          this.load(false);
          const { code, msg, data } = response;
          if (code >= 0) {
            this.incomeStatisticsData = data;
          }
        })
        .catch(response => {
          this.load(false);
          //this.tips(`${response.msg}`);
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
        });
    },
    //用户收益
    getStoreIncomePager() {
      this.listQueryByIncome.IncomeType = this.curIncomeType;
      this.listQueryByIncome.Year = moment(this.searchTime).format("YYYY");
      this.listQueryByIncome.Month = moment(this.searchTime).format("MM");
      //console.info('getStoreIncomePager', this.listQueryByIncome)
      this.load(true, "加载中...");

      const param1 = this.listQueryByIncome;
      getStoreIncomePager(param1)
        .then(response => {
          this.load(false);
          const { code, msg, data } = response;
          if (code >= 0) {
            //console.info('getStoreIncomePager -> data', data)
            this.listByIncome = data.list;
          }
        })
        .catch(response => {
          this.load(false);
          //this.tips(`${response.msg}`);
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
        });

      const param2 = Object.assign({}, this.listQueryByIncome); // copy obj
      param2.Status = 2;
      getStoreIncomePager(param2)
        .then(response => {
          this.load(false);
          const { code, msg, data } = response;
          if (code >= 0) {
            //console.info('getStoreIncomePager2 -> data', data)
            this.listByIncome2 = data.list;
          }
        })
        .catch(response => {
          this.load(false);
          //this.tips(`${response.msg}`);
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
        });
    },
    //提现记录
    getStoreExtractCashPager() {
      this.listQueryByExtractCash.Year = moment(this.searchTime).format("YYYY");
      this.listQueryByExtractCash.Month = moment(this.searchTime).format("MM");
      //console.info('getStoreExtractCashPager', this.listQueryByExtractCash)
      this.load(true, "加载中...");
      getStoreExtractCashPager(this.listQueryByExtractCash)
        .then(response => {
          this.load(false);
          const { code, msg, data } = response;
          if (code >= 0) {
            //console.info('getStoreExtractCashPager -> data', data)
            this.listByExtractCash = data.list;
          }
        })
        .catch(response => {
          this.load(false);
          //this.tips(`${response.msg}`);
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
        });
    },
    //检查是否已绑定微信
    checkWeixin() {
      this.load(true, "加载中...");
      getUser()
        .then(response => {
          this.load(false);
          //console.info('getUser -> response', response)
          if (!response.openId) {
            Dialog.confirm({
              title: "确认操作",
              message: `您当前没有绑定微信账号，是否现在进行绑定？\r\n注意：以后收益将提现到绑定的微信账号上，且不可变更绑定`
            }).then(() => {
              // on confirm
              window.location.href="/User/bindWechat";
            });
          }
          else {
            const amonut = parseFloat(
              this.incomeStatisticsData.total_Status3_Income
            );
            this.mobile = response.mobile;
            this.caseAmount = amonut;
            this.getVerifyCodeImageBase64();
            this.mobileCodeShow = true;
            //this.openid = response.openId;            
          }
        })
        .catch(response => {
          this.load(false);
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
        });
    },
    //跳转到微信网页授权
    redirectToWeixin() {
      const url = `${window.location.origin + window.location.pathname}`;
      window.location.href = GetWechatAuthUrl(url);
    },
    //提现
    getCash() {
      const amonut = parseFloat(this.incomeStatisticsData.total_Status3_Income);
      if (amonut == 0) {
        this.tips("当前没有可以提现的金额");
        return;
      }
      if (amonut < 1) {
        this.tips("最少提现金额为1元，当前金额不可以提现", 1000 * 5);
        return;
      }
      this.checkWeixin();
    },
    getCashConfirm() {
      if(this.checkboxState != true) {
        this.tips("请勾选服务条款", 1000 * 2);
        return;
      }
      if (this.verifyCode == "") {
        this.tips("请输入图形验证码", 1000 * 3);
        return;
      }
      if (this.mobileCode == "") {
        this.tips("请输入短信验证码", 1000 * 3);
        return;
      }
      const amonut = parseFloat(this.incomeStatisticsData.total_Status3_Income);
      this.load(true, "加载中...");
      getCash({
        cashAmount: amonut,
        code: this.mobileCode,
        openid: this.openid
      })
        .then(response => {
          this.load(false);
          const { code, msg, data } = response;
          if (code >= 0) {
            this.tips("已提现成功");
            this.mobileCodeShow = false;
            this.onLoad();
          }
        })
        .catch(response => {
          this.load(false);
          //this.tips(`提现失败。${response.msg}`);
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
          if(response.code == -100) {
            setTimeout(() => {
              window.location.href="/User/bindWechat";
            }, 1000);   
          }
        });
    },
    beforeClose(action, done) {
      if (action == "cancel") done();
      else done(false);
    },
    // 图形验证码
    getVerifyCodeImageBase64: function() {
      verifyCodeImageBase64()
        .then(response => {
          const { code, msg, data } = response;
          if (code >= 0) {
            //console.info('verifyCodeImageBase64 -> data', data)
            this.verifyCodeImageBase64 = data.base64String;
          }
        })
        .catch(response => {
          this.tips(`${response.msg}`);
        });
    },
    handleVerifyCodeClick() {
      this.getVerifyCodeImageBase64();
    },
    //发送验证码
    getCode() {
      if (this.verifyCode == "") {
        this.tips("请输入图形验证码", 1000 * 3);
        return;
      }
      //验证图形验证码，正常才发送手机验证码
      sendCode("123", this.verifyCode, "getCash")
        .then(response => {
          const { code, msg, data } = response;
          if (code >= 0) {
            //console.info('sendCode -> data', data)
            //this.sendCodeText = '60s'
            let self = this;
            if (self.codeTime == 0) {
              self.tips("验证码已发送，请注意查收");
              self.codeTime = 60;
              // 自调用
              self.timeOut = setInterval(() => {
                self.codeTime--;
                self.sendCodeText = self.codeTime + "s";
                if (self.codeTime === 0) {
                  clearInterval(self.timeOut);
                  self.sendCodeText = "发送";
                }
              }, 1000);
            }
          }
        })
        .catch(response => {
          this.tips(`${response.msg}`);
        });
    },
    //显示条款
    showTiaokuan() {
      this.AgreementShow = true;
    },
    //勾选
    checkboxClick(obj) {
      this.checkboxState = obj.target.checked
    }
  },
  components: {
    hshead,
    agreement: Agreement,
    "van-datetime-picker": DatetimePicker,
    "van-popup": Popup,
    "van-tabs": Tabs,
    "van-tab": Tab,
    "van-tabbar": Tabbar,
    "van-tabbar-item": TabbarItem,
    "van-button": Button,
    [Dialog.Component.name]: Dialog.Component,
    "van-field": Field,
    "van-cell-group": CellGroup,
    "van-cell": Cell
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/common.less";
@import "~@/assets/less/mixin.less";
.income-box {
  position: relative;
  .income-time-select {
    width: 2.6rem;
    font-family: PingFang-SC-Medium;
    font-size: 0.24rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0rem;
    color: #ffffff;
    text-align: right;
    position: absolute;
    right: 0.3rem;
    top: 0.32rem;
    .this-time {
      span {
        font-size: 0.2rem;
        display: inline-block;
        img {
          width: 0.2rem;
        }
      }
    }
  }
  .income-top {
    display: flex;
    margin-top: -3.5rem;
    .top-left {
      width: 3.41rem;
      height: 1.04rem;
      border-right: 1px solid rgba(255, 255, 255, 0.6);
      .this-p {
        font-family: PingFang-SC-Medium;
        font-size: 0.3rem;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0rem;
        color: #ffffff;
        padding-left: 1rem;
        padding-bottom: 0.15rem;
      }
    }
    .top-right {
      flex: 1;
      display: flex;
      .this-img {
        width: 1.9rem;
        text-align: center;
        img {
          width: 0.77rem;
          height: 0.78rem;
          display: inline-block;
        }
      }
      .this-btn {
        display: block;
        text-align: center;
        margin-top: 0.3rem;
        width: 1.9rem;
        height: 0.51rem;
        background-color: #f3f9fe;
        border-radius: 0.06rem;
        opacity: 0.8;
        font-family: PingFang-SC-Medium;
        font-size: 0.24rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.51rem;
        letter-spacing: 0rem;
        color: #4570f6;
      }
    }
  }
  .income-tab {
    margin-top: 1.65rem;
    background: #fff;
    .income-ul {
      margin-top: 0.5rem;
      margin-bottom: 1.5rem;
      .income-li {
        display: flex;
        width: 6.7rem;
        height: 2.01rem;
        background-color: #fff;
        box-shadow: 0rem 0rem 0.12rem 0rem rgba(34, 138, 255, 0.22);
        border-radius: 0.06rem;
        margin: 0 auto;
        margin-bottom: 0.35rem;
        .left-img {
          width: 1.6rem;
          margin-top: 0.5rem;
          img {
            display: inline-block;
            width: 1.33rem;
            height: 0.93rem;
          }
        }

        .center-p-box {
          flex: 1;
          margin-top: 0.4rem;
          .center-p {
            font-family: PingFang-SC-Medium;
            font-size: 0.24rem;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #333333;
            padding-bottom: 0.25rem;
            &.min {
              margin-right: -1rem;
            }
          }
        }
        .right-img {
          margin-top: 0.14rem;
          width: 1rem;
          img {
            width: 0.9rem;
            height: 0.9rem;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/grapher/income.vue